export default "__VITE_ASSET__Bct3at4O__"